import {AsyncPipe, NgClass} from '@angular/common';
import {Component, HostListener, inject} from '@angular/core';
import {ModalService} from '@core/services/modal.service';
import {ModalHandle} from '@core/types';
import {ModalOutlet} from '@core/modals';

@Component({
  selector: 'core-modal-host',
  standalone: true,
  imports: [AsyncPipe, NgClass, ModalOutlet],
  templateUrl: './modal-host.html',
})
export class ModalHost {
  private readonly modal = inject(ModalService);
  readonly stack$ = this.modal.stack$;

  trackById = (_: number, m: ModalHandle) => m.id;

  onBackdropClick(modalHandle: ModalHandle) {
    if (modalHandle.options.closeOnBackdrop) {
      this.modal.close(modalHandle.id);
    }
  }

  onCloseClick(modalHandle: ModalHandle) {
    this.modal.close(modalHandle.id);
  }

  @HostListener('document:keydown.escape')
  onEsc() {
    const stack = (this.modal as any)._stack$?.value as ModalHandle[] | undefined;
    const top = stack?.[stack.length - 1];
    if (top?.options.closeOnEsc) this.modal.closeTop();
  }

  sizeClass(size: ModalHandle['options']['size']) {
    return {
      sm: 'core-modal-panel--sm',
      md: 'core-modal-panel--md',
      lg: 'core-modal-panel--lg',
      xl: 'core-modal-panel--xl',
    }[size];
  }
}
